import axios from 'axios';
import { API_URL } from '../env';
import { normalize } from './helpers';

async function all() {
  const response = await axios.get(`${API_URL}/cards`);

  return normalize(response.data);
}

export {
  all,
};
